const metaData = {
    resizableSides: []
}

export default metaData
